
/**
 * Cookie Helper
 */
class CookieHelper {

    /**
     * Gets value from requested key in cookies.
     * @returns string
     */
    static get(key) {
       let pair = document.cookie.match(new RegExp(key + '=([^;]+)'));
      return !!pair ? pair[1] : '';
    }
}

export default CookieHelper;



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/helpers/cookie-helper.js
// module id = 124
// module chunks = 4